// src/pages/admin/jobDetail/helpers.js — pure formatting/calculation helpers used by
// JobDetailPage. No React state; every function is a function of its arguments only.

export const FUTILE_CHARGE_AMOUNT = 180;

export const linkify = (text = "") => {
  const urlRe = /\b(https?:\/\/[^\s)]+|\bwww\.[^\s)]+)\b/gi;
  return String(text || "").replace(urlRe, (m) => {
    const url = m.startsWith("http") ? m : `https://${m}`;
    return `<a href="${url}" target="_blank" rel="noopener noreferrer" class="text-blue-700 underline">${m}</a>`;
  });
};

export const addrToText = (addr) => {
  if (!addr) return "";
  if (typeof addr === "string") return addr;
  if (typeof addr === "object") {
    const {
      line1,
      line2,
      suburb,
      city,
      town,
      state,
      stateCode,
      postcode,
      postCode,
      postalCode,
      country,
      address,
      formatted,
      label,
      name,
    } = addr;
    const parts = [
      formatted || address || label || name || "",
      line1,
      line2,
      suburb || city || town,
      state || stateCode,
      postcode || postCode || postalCode,
      country,
    ].filter(Boolean);
    const seen = new Set();
    return parts
      .filter((p) => (seen.has(p) ? false : (seen.add(p), true)))
      .join(", ");
  }
  return String(addr);
};

export const esc = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;

export const hasValue = (value) => {
  if (value === null || value === undefined) return false;
  if (typeof value === "string") return value.trim() !== "";
  return true;
};

export const firstDefined = (...values) => values.find((value) => value !== undefined && value !== null);

export const asNumber = (value) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
};

export const isSilicaMaterialName = (name) =>
  String(name || "").trim().toLowerCase().includes("silica");

export const getQty = (item) =>
  asNumber(
    item?.qty ??
      item?.quantity ??
      item?.count ??
      item?.units ??
      item?.total ??
      0
  );

export const fmtDateTime = (value) => {
  if (!value) return "-";
  try {
    if (typeof value?.toDate === "function") {
      return value.toDate().toLocaleString("en-AU", { hour12: false });
    }
    if (typeof value === "object" && typeof value.seconds === "number") {
      return new Date(value.seconds * 1000).toLocaleString("en-AU", {
        hour12: false,
      });
    }
    if (typeof value === "number") {
      const date = value > 1e12 ? new Date(value) : new Date(value * 1000);
      return Number.isNaN(date.getTime())
        ? String(value)
        : date.toLocaleString("en-AU", { hour12: false });
    }
    if (typeof value === "string") {
      const parsed = new Date(value);
      return Number.isNaN(parsed.getTime())
        ? value
        : parsed.toLocaleString("en-AU", { hour12: false });
    }
  } catch {}
  return String(value);
};

export const fmtCurrency = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return "-";
  try {
    return new Intl.NumberFormat("en-AU", {
      style: "currency",
      currency: "AUD",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(n);
  } catch {
    return `$${n.toFixed(2)}`;
  }
};

export const sourceLabel = (source) => {
  if (source === "emptied") return "Emptied";
  if (source === "empty-load") return "Empty load";
  if (source === "overload") return "Overload";
  return "Job";
};
